import  AllKyc  from "../../components/admin/AllKyc";

export default function AllKycPage() {
  return <AllKyc />;
}